"use client";

import { AK } from "@/constants";
import { AxiosPost } from "@/utilities/axioscall";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import FadeLoader from "react-spinners/FadeLoader";
import Image from "next/image";
import visa from "@/public/assets/images/visa.png";
import paypal from "@/public/assets/images/paypal.png";
import master from "@/public/assets/images/master.png";
import { FaInstagramSquare } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { getLegalEntity, getLogo, getStoreTitle } from "@/services/storeService";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Link from "next/link";

const Footer = ({ categoryListData }: any) => {
  const [formValues, setFormValues] = useState({
    newsemail: "",
    newsemailError: false,
    formloading: false,
  });

  const [isFootConVisible, setIsFootConVisible] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    let error = false;
    if (!formValues.newsemail) {
      setFormValues((prev) => ({ ...prev, newsemailError: true }));
      error = true;
    } else {
      setFormValues((prev) => ({ ...prev, newsemailError: false }));
    }

    if (error) return;

    setFormValues((prev) => ({ ...prev, formloading: true }));

    try {
      const res = await AxiosPost(AK.NEWSLETTERFORMAPI, { email: formValues.newsemail });
      if (typeof res !== "string" && res?.data) {
        toast.success("Newsletter subscribed successfully.", {
          style: { border: "1px solid #00b852", padding: "16px", color: "#00b852" },
          iconTheme: { primary: "#00b852", secondary: "#FFFAEE" },
        });
        setFormValues({ newsemail: "", newsemailError: false, formloading: false });
      } else {
        toast.error("Newsletter validation error.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setFormValues((prev) => ({ ...prev, formloading: false }));
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const toggleFootConVisibility = () => setIsFootConVisible((v) => !v);

  return (
    <>
      <footer className="bg-black text-white">
        <div className="container mx-auto px-4 py-12">
          {/* Top Links */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
            <Link href="/">
              <LazyLoadImage
                className="mx-auto"
                width="100"
                src={`${getLogo()}`}
                onError={(e) => {
                  e.currentTarget.src =
                    "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
                }}
                alt={`${getStoreTitle()}`}
              />
            </Link>

            <div>
              <h3 className="text-lg font-medium mb-6">INFORMATION</h3>
              <ul className="space-y-3 text-gray-400 text-base">
                <li><a href="/about-us" className="hover:text-white transition">About Us</a></li>
                <li className="cursor-pointer hover:text-white transition">FAQs</li>
                <li className="cursor-pointer hover:text-white transition">Store Location</li>
                <li><a href="/contactus" className="hover:text-white transition">Contact Us</a></li>
                <li><a href="/blog" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Blog</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-6">POLICY</h3>
              <ul className="space-y-3 text-gray-400 text-base">
                <li><a href="/privacypolicies" className="hover:text-white transition">Privacy Policy</a></li>
                <li><a href="/termsandcondition" className="hover:text-white transition">Terms & Conditions</a></li>
                <li><a href="/shippingandrefundpolicy" className="hover:text-white transition">Shipping & Refund Policy</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium mb-6">CONTACT</h3>
              <ul className="space-y-3 text-gray-400 text-base">
                <li><a href="tel:+919384948885" className="hover:text-white transition">+91 93849 48885</a></li>
                <li><a href="mailto:thefanboy.in@gmail.com" className="hover:text-white transition">thefanboy.in@gmail.com</a></li>
              </ul>
            </div>
          </div>

          {/* Newsletter + Payment + Social */}
          <div className="grid grid-cols-1  md:grid-cols-3 gap-10 py-8 ">
            {/* Newsletter */}
            <div className="flex flex-col items-start">
              <h4 className="text-lg font-medium uppercase mb-4">Subscribe to Our Emails</h4>
              <form onSubmit={handleSubmit} className="flex flex-col w-full max-w-sm gap-3">
                <div className="flex gap-2">
                  <input
                    type="email"
                    name="newsemail"
                    value={formValues.newsemail}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="flex-1 h-12 px-4 bg-gray-800 text-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white transition"
                  />
                  <button
                    type="submit"
                    disabled={formValues.formloading}
                    className="h-12 px-6 bg-white text-black font-medium hover:bg-gray-200 transition"
                  >
                    JOIN NOW
                  </button>
                </div>
                <FadeLoader loading={formValues.formloading} color="#5475E5" height={10} width={2} />
                {formValues.newsemailError && (
                  <p className="text-red-500 text-sm">Please enter your email.</p>
                )}
              </form>
            </div>

            {/* Payment Methods */}
            <div className="flex flex-col">
              <h5 className="text-lg font-medium mb-4">Legal Entity : {getLegalEntity()}</h5>
              <div className="flex items-center gap-6 mt-6">
                <Image src={visa} alt="Visa" className="h-10 w-auto" />
                <Image src={paypal} alt="PayPal" className="h-10 w-auto" />
                <Image src={master} alt="MasterCard" className="h-10 w-auto" />
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex flex-col">
              <h5 className="text-lg font-medium mb-4">Social</h5>
              <div className="flex gap-4 mt-6">
                <FaInstagramSquare className="w-9 h-9 p-1.5 bg-white text-black rounded hover:text-instagram transition-all hover:scale-110" />
                <BsWhatsapp className="w-9 h-9 p-1.5 bg-white text-black rounded hover:text-whatsapp transition-all hover:scale-110" />
                <FaFacebook className="w-9 h-9 p-1.5 bg-white text-black rounded hover:text-facebook transition-all hover:scale-110" />
                <FaYoutube className="w-9 h-9 p-1.5 bg-white text-black rounded hover:text-youtube transition-all hover:scale-110" />
                <FaXTwitter className="w-9 h-9 p-1.5 bg-white text-black rounded hover:text-twitter transition-all hover:scale-110" />
              </div>
            </div>
          </div>

          {/* More About Toggle */}
          <div className="text-center py-8">
            <button
              onClick={toggleFootConVisibility}
              className="inline-flex items-center gap-3 text-white hover:underline"
            >
              <span className="text-base font-medium">MORE ABOUT FAN BOY STORE</span>
              <svg
                className={`w-5 h-5 transition-transform ${isFootConVisible ? "rotate-180" : ""}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          {/* Expandable Long Content */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${isFootConVisible ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"
              }`}
          >
            <div className="space-y-8 text-gray-400">
              <div>
                <h6 className="text-xl font-medium text-white mb-4">FAN BOY STORE THE NEW AGE ONLINE SHOPPING EXPERIENCE</h6>
                <p className="text-base leading-7">fanboystore is a lifestyle fashion brand committed to crafting innovative and distinctive fashion for the trendy, contemporary Indian...</p>
              </div>
              {/* Repeat other <h6> + <p> blocks as needed – omitted for brevity */}
              <div>
                <h6>FAN BOY STORE THE NEW AGE ONLINE SHOPPING EXPERIENCE</h6>
                <p>
                  fanboystore is a lifestyle fashion brand committed to crafting
                  innovative and distinctive fashion for the trendy, contemporary
                  Indian. Our brand was born out of a dedication to making a
                  positive impact through innovation, honesty, and thoughtfulness.
                  We constantly strive to provide an altered and improved fashion
                  experience that goes beyond the ordinary, ensuring that our
                  creations resonate with your individuality and style. At
                  fanboystore, we believe in setting new standards and pushing
                  boundaries, offering you a fashion journey that is both meaningful
                  and unique.
                  <br />
                </p>
                <h6>
                  ONLINE SHOPPING AT FAN BOY STORE T-SHIRTS IS HASSLE-FREE,
                  CONVENIENT AND SUPER-EXCITING!
                </h6>
                <p>
                  Transforming the shopping experience, online shopping is now a
                  delightful journey right from the comfort of your home. Gone are
                  the days of planning trips to physical stores; today, you can
                  indulge in the excitement of online shopping with fanboystore.in.
                  Explore a world of amazing deals, discounts, and a user-friendly
                  interface that stands out among other online shopping sites in
                  India. With numerous shopping filters, we ensure your experience
                  is truly hassle-free. Welcome to fanboystore.in, where convenience
                  meets exceptional offers, making online shopping a joyous affair
                  in every click.
                  <br />
                  <br />
                  Welcome to fanboystore, your ultimate destination for the
                  trendiest online fashion. Explore our curated collection of fine,
                  high-quality merchandise and embark on a delightful online
                  shopping experience for both men and women. Discover a diverse
                  range, from men's fashion to essential clothing items, as well as
                  a wide variety of women's wear and accessories. Simply fill up
                  your carts and enjoy swift home delivery for all orders. Indulge
                  in the latest fashion trends with fanboystore, where style meets
                  convenience. Our exciting categories, combined with exclusive
                  online shopping offers, create an irresistible and uber cool combo
                  for fashion enthusiasts. Whether you're shopping for yourself or
                  looking for the perfect gift, fanboystore guarantees a smile on
                  the faces of your near and dear ones. Elevate your fashion journey
                  with fanboystore, where every click is a step towards style and
                  satisfaction.
                </p>
                <h6>
                  fanboystore.in: THE QUIQUICKEST ONLINE SHOPPING SITES OF ALL!
                </h6>
                <p>
                  Experience the epitome of accessible online fashion with
                  fanboystore.in. Dive into our latest collections featuring Marvel
                  t-shirts, including official Avengers and Captain America
                  merchandise. We specialize in creating personalized Tamil word
                  t-shirts and Tamil letter t-shirts, adding a unique touch to your
                  wardrobe. Discover the quickest t-shirts unavailable on any other
                  Indian online shopping site, exclusively showcased at
                  fanboystore.in. If your wardrobe craves a stylish transformation,
                  fanboystore.in stands as your top choice among online shopping
                  sites. Explore our diverse range, from trendy sliders and joggers
                  to cozy sweatshirts, fashionable bags, and backpacks. At
                  fanboystore.in, fashion doesn't have to break the bank. Say
                  goodbye to expensive alternatives; here, you'll find affordable
                  and chic options to elevate your style.
                  <br />
                  What you wear is a reflection of your mood, and we've got the
                  quirky t-shirts that allow you to express yourself with
                  confidence. Take a journey through the latest runway trends on our
                  fanboystore.in blog and become a trendsetter among your peers.
                  With us, you're not just shopping; you're defining your style
                  story. No tags, just seamless style and unbeatable affordability,
                  making fanboystore.in your go-to destination for a fashion-forward
                  online experience.
                </p>
                <h6>
                  DONT MISS OUT ON ACCESSORIES AVAILABLE ON OUR MULTI-FACETED ONLINE
                  STORE!
                </h6>
                <p>
                  Explore beyond the ordinary in online fashion with fanboystore.in,
                  where we don't just provide thrilling clothing options but also
                  offer an array of fabulous accessories, featuring exceptionally
                  cool bags and backpacks. Our collection is designed for those who
                  appreciate compactness, hassle-free functionality, and the ease of
                  storing essentials. Carry your belongings with an added touch of
                  swag, thanks to our stylish designs.
                  <br />
                  <br />
                  At fanboystore.in, we believe in ensuring that our accessories
                  section is just as captivating as our clothing line. Immerse
                  yourself in the world of cool designs that effortlessly complement
                  your style. Our bags and backpacks are not just accessories; they
                  are a statement. With fanboystore.in, step into a realm where
                  online fashion seamlessly combines practicality, style, and a
                  touch of swag, ensuring you never compromise on individuality and
                  convenience.As for our accessories collection, they are also
                  manufactured with impeccable quality materials. Our mobile covers
                  are made from hard and durable polycarbonate, with a matte finish
                  that will make for a great protection for your phone with the
                  rough use that we put them through nowadays.
                </p>
                <h6>
                  fanboystore.in: THE UBER COOL ONLINE FASHION STORE FOR THE YOUTH
                </h6>
                <p>
                  At fanboystore.in, we offer everything you need to elevate your
                  cool quotient. Our extensive range includes plus-size clothing,
                  casual shirts for men, and accessories for everyone. We bring
                  forth a diverse array of choices, consolidating the best options
                  that the online shopping platform in India has to offer under one
                  umbrella. Explore a vast selection of men's t-shirts, joggers,
                  sliders, Henley shirts, Polo t-shirts, Oxford pants, and more to
                  curate a stunning ensemble. Our goal is to cater to all kinds of
                  customers by understanding their needs and preferences.
                  Communication is the cornerstone of our operation. Welcome to your
                  FAN BOY STORE Online Fashion Shop! Don't miss out on our
                  attractive daily online shopping offers. Express your style
                  effortlessly with our wide range of apparels just a click away.
                  Make a statement with our premium t-shirts online—more style, more
                  value. Get more, pay less! Your fashion journey begins here.
                </p>
                <h6>OUR PHILOSOPHY</h6>
                <p>
                  At FAN BOY STORE, our mission is to craft fashion that not only
                  aligns with the latest local and global trends but also provides
                  functional value for your money. We prioritize quality materials,
                  ensuring comfortable and flattering prints that make you stand
                  out. We delve into the minds of our customers, drawing inspiration
                  from their conversations and experiences to create graphics that
                  resonate and relate. Constant and consistent innovation is at our
                  core, offering our fans nothing short of the best at affordable
                  rates. Unlike many, we don't outsource manufacturing; from design
                  conception to production and styling, everything happens in-house.
                  We're vertically integrated, bringing fashion directly from us to
                  your doorstep without middlemen, ensuring reliability and building
                  trust with our fans. Environmental impact is a concern, and we're
                  actively implementing initiatives, such as optimizing processes to
                  use only what we need from nature, rainwater harvesting, and
                  recycling water from our RO facility. At FAN BOY STORE, our spirit
                  is about making an impact by breaking conventions and offering a
                  different perspective!
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Tailwind custom colors for social hover (add to globals.css if not already) */}
      <style jsx global>{`
        .hover\\:text-instagram:hover { color: #E4405F; }
        .hover\\:text-whatsapp:hover { color: #25D366; }
        .hover\\:text-facebook:hover { color: #1877F2; }
        .hover\\:text-youtube:hover { color: #FF0000; }
        .hover\\:text-twitter:hover { color: #0e6194; }
      `}</style>
    </>
  );
};

export default Footer;